import { Component, OnInit } from "@angular/core";

@Component({
  selector: "maintenance-historico-bastidor",
  templateUrl: "./maintenance-historico-bastidor.component.html",
  // styleUrls: ['./maintenance-historico-bastidor.component.sass']
})
export class MaintenanceHistoricoBastidorComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
